//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.CartMetaInfo
import com.tixforgigs.apax.models.CartPriceInfo
import com.tixforgigs.apax.models.ShoppingCartItem
import com.tixforgigs.apax.models.Voucher

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The shopping cart model.
* 
* @param cartId The shopping cart id
* @param cartMetaInfo 
* @param cartPriceInfo 
* @param cartVerificationToken The shopping cart verification token
* @param floorPlanHoldToken The seats.io hold token
* @param items The shopping cart items
* @param reservationExpires The reservation timeout offset in milliseconds.
* @param reservationExpiresUTC The reservation timeout as utc date time
* @param scmId The selected shipping option, selected/saved on cart, not the same as shippingMethodId
* @param termsAndConditions The terms and conditions to accept
* @param userData The user token
* @param voucherItems The voucher items
*/
@Serializable

data class ShoppingCart (


      /* The shopping cart id */
    @SerialName(value = "cartId") val cartId: kotlin.uuid.Uuid? = null,


      @SerialName(value = "cartMetaInfo") val cartMetaInfo: CartMetaInfo? = null,


      @SerialName(value = "cartPriceInfo") val cartPriceInfo: CartPriceInfo? = null,


      /* The shopping cart verification token */
    @SerialName(value = "cartVerificationToken") val cartVerificationToken: kotlin.String? = null,


      /* The seats.io hold token */
    @SerialName(value = "floorPlanHoldToken") val floorPlanHoldToken: kotlin.String? = null,


      /* The shopping cart items */
    @SerialName(value = "items") val items: kotlin.collections.List<ShoppingCartItem>? = null,


      /* The reservation timeout offset in milliseconds. */
    @SerialName(value = "reservationExpires") val reservationExpires: kotlin.Int? = null,


      /* The reservation timeout as utc date time */
    @SerialName(value = "reservationExpiresUTC") val reservationExpiresUTC: kotlin.time.Instant? = null,


      /* The selected shipping option, selected/saved on cart, not the same as shippingMethodId */
    @SerialName(value = "scmId") val scmId: kotlin.Int? = null,


      /* The terms and conditions to accept */
    @SerialName(value = "termsAndConditions") val termsAndConditions: kotlin.Boolean? = null,


      /* The user token */
    @SerialName(value = "userData") val userData: kotlin.String? = null,


      /* The voucher items */
    @SerialName(value = "voucherItems") val voucherItems: kotlin.collections.List<Voucher>? = null


) {




  }

